import moment from "moment";
import { Field } from "./field";
import { OrderedMap, Record } from "immutable";

const defaults = {
    _id: undefined,
    active: false,
    brand: undefined,
    composite_key_fields: [],
    created_on: undefined,
    fields: OrderedMap,
    modified_on: undefined,
    name: "",
    type: "",
};

export class SchemaRecord extends Record(defaults) {
    declare _id: string;
    declare type: string;
    declare name: string;
    declare brand?: string;
    declare active: boolean;
    declare composite_key_fields: string[];
    declare created_on: moment.Moment;
    declare modified_on: moment.Moment;
    declare fields: OrderedMap<string, Field>;

    constructor(args: any = {}) {
        super({
            ...args,
            created_on: moment.utc(args.created_on),
            fields: OrderedMap(
                args.fields &&
                    args.fields.map((val) => {
                        return [val.key, new Field(val)];
                    })
            ),
            modified_on: moment.utc(args.modified_on),
        });
    }

    getFieldsForShippingPromotions() {
        return this.fields.filter((field) => {
            return !!field && field.key.indexOf("line_items.") === -1;
        });
    }

    toJS() {
        const js = super.toJS();
        js.fields = Object.keys(js.fields).map((key) => js.fields[key]);
        Object.keys(js).forEach((key) => {
            if (typeof js[key] === "undefined") {
                delete js[key];
            }
        });
        return js;
    }
}
